const commonSetting = {
  apstag: true,
  targeting: {
    category: 'DATA'
  }
}
const gptConf = [
  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_atf_pc', size: [[320, 100], [640, 100], [320, 50]], slotId: 'ads-atf', targetPlatform: 'pc' },
  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_btf_pc', size: [[320, 180], [300, 250], [336, 280], [200, 200]], slotId: 'ads-btf', targetPlatform: 'pc' },
  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_below_week_pc', size: [[336, 280]], slotId: 'ads-btf2-left-pc', targetPlatform: 'pc', hasParent: true },
  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_below_week_pc_right', size: [[336, 280]], slotId: 'ads-btf2-right-pc', targetPlatform: 'pc', hasParent: true },

  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_atf2', size: [[320, 100], [320, 50]], slotId: 'ads-atf', targetPlatform: 'sp' },
  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_btf', size: [[336, 280], [300, 250], [320, 180], [200, 200]], slotId: 'ads-btf', targetPlatform: 'sp' },
  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_below_week_pc', size: [[336, 280], [300, 250]], slotId: 'ads-btf1-sp', targetPlatform: 'sp' },

  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_btm_pc', size: [[200, 200], [300, 600], [336, 280], [120, 600], [300, 250], [160, 600]], slotId: 'ads-btm', targetPlatform: 'pc' },
  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_btm', size: [[200, 200], [300, 600], [336, 280], [120, 600], [300, 250], [160, 600]], slotId: 'ads-btm', targetPlatform: 'sp' },

  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_sticky_ad', size: [[320, 50], [320, 100]], slotId: 'div-gpt-ad-sticky', sticky: true, targetPlatform: 'sp', hasParent: true },
  { ...commonSetting, unitCode: '/284705699/Onebox/Onebox_stickyad_pc', size: [[970, 90], [640, 100], [640, 50], [950, 90], [728, 90], [950, 70]], slotId: 'div-gpt-ad-1666850974098-0', sticky: true, targetPlatform: 'pc', hasParent: true }
]
export const adsConfig = {
  gptConf,
  usePrebids: true,
  lazyload: true
}
